import {
  PAGE_TRACKING,
  getTrackingCategoryName,
} from "~/tools/getTrackingCategoryName";

export enum ActionsEnum {
  PRIME_LIGHTBOX = "prime_lightbox",
  PRIME_FIRST_BENEFITS = "prime-first_c4ar_benefits",
}

export enum BENEFIT_KEYS {
  DISCOUNTS = "visibility.lightbox.section.one.accordion.one.title",
  FRIENDS_AND_FAMILY = "visibility.lightbox.section.one.accordion.two.title",
  PROMOCODES = "visibility.lightbox.section.one.accordion.three.title",
  SALES = "visibility.lightbox.section.one.accordion.four.title",
  PRICE_FREEZE = "visibility.lightbox.section.two.accordion.one.title",
  FREE_CANCELLATION = "visibility.lightbox.section.two.accordion.two.title",
  FREE_CANCELLATION_FREE_TRIAL = "visibility.lightbox.section.two.accordion.two.freetrial.title",
  VIP_SUPPORT = "visibility.lightbox.section.three.accordion.one.title",
  AIRLINE_REFUNDS = "visibility.lightbox.section.three.accordion.two.title",
}

export enum BENEFIT_TRACKING {
  DISCOUNTS = "discounts",
  FRIENDS_AND_FAMILY = "f&f",
  PROMOCODES = "promocodes",
  SALES = "sales",
  PRICE_FREEZE = "price-freeze",
  FREE_CANCELLATION = "c4ar",
  FREE_CANCELLATION_FREE_TRIAL = "c4ar_benefit",
  VIP_SUPPORT = "vip-support",
  AIRLINE_REFUNDS = "airline-refunds",
}

const WIDGET = "prime_lightbox";

export const getCategoryLabel = (pathname: string): string => {
  return getTrackingCategoryName("", "", "", pathname);
};

const benefitTrackingTitleMap = {
  [BENEFIT_KEYS.FRIENDS_AND_FAMILY]: BENEFIT_TRACKING.FRIENDS_AND_FAMILY,
  [BENEFIT_KEYS.PROMOCODES]: BENEFIT_TRACKING.PROMOCODES,
  [BENEFIT_KEYS.SALES]: BENEFIT_TRACKING.SALES,
  [BENEFIT_KEYS.PRICE_FREEZE]: BENEFIT_TRACKING.PRICE_FREEZE,
  [BENEFIT_KEYS.FREE_CANCELLATION]: BENEFIT_TRACKING.FREE_CANCELLATION,
  [BENEFIT_KEYS.FREE_CANCELLATION_FREE_TRIAL]:
    BENEFIT_TRACKING.FREE_CANCELLATION_FREE_TRIAL,
  [BENEFIT_KEYS.VIP_SUPPORT]: BENEFIT_TRACKING.VIP_SUPPORT,
  [BENEFIT_KEYS.AIRLINE_REFUNDS]: BENEFIT_TRACKING.AIRLINE_REFUNDS,
};

const yLabelMap = {
  [PAGE_TRACKING.FLIGHTS_RESULTS]: "flres",
  [PAGE_TRACKING.PRIME_PAGE]: "fares",
};

const getYLabel = (category: string): string => {
  return yLabelMap[category] || "flpay";
};

const getVLabel = (isOpen: boolean): string => {
  return isOpen ? "close" : "open";
};

export const trackingLabels = {
  onLoad: ({ pathname }): string => {
    const category = getCategoryLabel(pathname);

    return `${WIDGET}_onload_pag:${getYLabel(category)}`;
  },
  onLoadWithBenefitOpened: ({ pathname, key }): string => {
    const category = getCategoryLabel(pathname);

    return `${WIDGET}_${key}_onload_pag:${getYLabel(category)}`;
  },
  onClose: ({ pathname }): string => {
    const category = getCategoryLabel(pathname);

    return `${WIDGET}_click_close_pag:${getYLabel(category)}`;
  },
  onTabChanged: ({ pathname, tabSelected }): string => {
    const category = getCategoryLabel(pathname);
    return `${WIDGET}_click_tab-${tabSelected}_pag:${getYLabel(category)}`;
  },
  onClickExpandBenefit: ({ pathname, key, isOpen }): string => {
    const category = getCategoryLabel(pathname);

    return `${WIDGET}_click_${getVLabel(isOpen)}-benefit-${key}_pag:${getYLabel(category)}`;
  },
  onLoadTooltip: ({ pathname }): string => {
    const category = getCategoryLabel(pathname);

    return `${WIDGET}_tooltip_onload_pag:${getYLabel(category)}`;
  },
  onClickSeeMoreBenefits: ({ pathname }): string => {
    const category = getCategoryLabel(pathname);

    return `${WIDGET}_click_continue-prime_pag:${getYLabel(category)}`;
  },
  onClickContinueBooking: ({ pathname }): string => {
    const category = getCategoryLabel(pathname);

    return `${WIDGET}_click_continue-booking_pag:${getYLabel(category)}`;
  },
};
